import { ref } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { apiClient } from '@/api/client'

const API_ORIGIN = (import.meta.env.VITE_API_BASE_URL as string || '').replace(/\/api\/v1\/?$/, '')

const fileTicket = ref<string | null>(null)
let ticketPromise: Promise<string | null> | null = null

export async function fetchFileTicket(): Promise<string | null> {
  if (fileTicket.value) return fileTicket.value
  if (ticketPromise) return ticketPromise
  
  ticketPromise = apiClient.get('/file-ticket').then(res => {
    fileTicket.value = res.data?.data?.ticket || null
    // Expire ticket cache a bit before 1 minute (e.g., 45 seconds)
    setTimeout(() => {
      fileTicket.value = null
      ticketPromise = null
    }, 45000)
    return fileTicket.value
  }).catch((err) => {
    console.warn('[secureFile] Failed to fetch file ticket:', err)
    ticketPromise = null
    return null
  })
  
  return ticketPromise
}

export function getPhotoUrl(candidateId?: string | null): string | null {
  const authStore = useAuthStore()
  if (!authStore.isAuthenticated || !fileTicket.value) return null

  if (authStore.role === 'candidate') {
    return `${API_ORIGIN}/api/v1/candidates/me/photo?ticket=${fileTicket.value}`
  } else if (authStore.role === 'hrd_admin') {
    if (!candidateId) return null
    return `${API_ORIGIN}/api/v1/candidates/${candidateId}/photo?ticket=${fileTicket.value}`
  } else if (authStore.role === 'interviewer') {
    if (!candidateId) return null
    return `${API_ORIGIN}/api/v1/interviewer/candidates/${candidateId}/photo?ticket=${fileTicket.value}`
  }
  return null
}

export function getResumeUrl(candidateId?: string | null): string | null {
  const authStore = useAuthStore()
  if (!authStore.isAuthenticated || !fileTicket.value) return null

  if (authStore.role === 'candidate') {
    return `${API_ORIGIN}/api/v1/candidates/me/cv?ticket=${fileTicket.value}`
  } else if (authStore.role === 'hrd_admin') {
    if (!candidateId) return null
    return `${API_ORIGIN}/api/v1/candidates/${candidateId}/cv?ticket=${fileTicket.value}`
  } else if (authStore.role === 'interviewer') {
    if (!candidateId) return null
    return `${API_ORIGIN}/api/v1/interviewer/candidates/${candidateId}/cv?ticket=${fileTicket.value}`
  }
  return null
}


